import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(11.000000, 5.000000)">
        {/* <path
          d="M45.691667,45.15 C48.591667,46.1 50.691667,48.95 50.691667,52.2 C50.691667,57.95 46.691667,61 40.291667,61 L28.541667,61 L28.541667,30.3 L39.291667,30.3 C45.691667,30.3 49.691667,33.15 49.691667,38.65 C49.691667,41.95 47.941667,44.35 45.691667,45.15 Z M33.591667,43.2 L39.241667,43.2 C42.791667,43.2 44.691667,41.85 44.691667,38.95 C44.691667,36.05 42.791667,34.8 39.241667,34.8 L33.591667,34.8 L33.591667,43.2 Z M33.591667,47.5 L33.591667,56.5 L40.191667,56.5 C43.691667,56.5 45.591667,54.75 45.591667,52 C45.591667,49.2 43.691667,47.5 40.191667,47.5 L33.591667,47.5 Z"
          fill="currentColor"
        /> */}
        <path fill="currentColor" d="M32.3,62.2c-5.9,0.5-1.8-23.3-3-26c-0.6-2-1.3-2.3-2.4-4.1C57.1,17.7,65.7,64,32.3,62.2z M37.6,34.3h-1.5
			l-0.9,0.1c-0.4,0-0.7,0.4-0.7,0.7v21.4c0,0.5,0.4,0.8,0.9,0.8l2.2-0.4c1-0.1,2-0.4,3.1-0.6c1-0.2,1.9-0.6,2.8-1
			c0.8-0.4,1.6-1,2.2-1.7c1.1-1.2,1.9-2.5,2.5-4c0.5-1.5,0.8-3.1,0.8-4.7c0-1.4-0.2-2.7-0.7-4c-0.4-1.3-1.1-2.4-2-3.4
			c-1-1-2.2-1.8-3.6-2.3C41,34.5,39.3,34.2,37.6,34.3z"/>
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
